import type { FC, ReactNode } from 'react'
import type { SiteSettings } from '@/types'

import { cn } from '@/lib/utils'
import { cms } from '@/lib/cms'
import { siteConfig } from '@/constants/site'

import LogoMark from '@/components/landing/logo-mark'

interface SiteLogoProps {
    settings: SiteSettings | null
    className?: string
}

// Shows the logo uploaded in the CMS (Site settings), or the drawn Spalogy
// mark with the site name until one is uploaded.
const SiteLogo: FC<SiteLogoProps> = ({ settings, className }): ReactNode => {
    if (settings?.logo) {
        return (
            <img
                src={settings.logo}
                alt={settings.logo_alt ?? settings.site_name}
                className={cn('h-8 w-auto', className)}
            />
        )
    }

    return (
        <span className={cn('inline-flex items-center gap-3', className)}>
            <LogoMark className='h-7' />

            {settings
                ? (
                    <span
                        data-mdlfy-cms={cms('site_settings', settings.id, 'site_name')}
                        className='font-heading text-[0.95rem] font-normal uppercase tracking-[0.34em]'
                    >
                        {settings.site_name}
                    </span>
                )
                : (
                    <span className='font-heading text-[0.95rem] font-normal uppercase tracking-[0.34em]'>
                        {siteConfig.name}
                    </span>
                )}
        </span>
    )
}

export default SiteLogo
